(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["yg-awards"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function() {
        class YGAwardsSwiper extends HTMLElement {
            constructor() {
                super();
                this.adjustSpeed();
            }

            adjustSpeed() {
                const track = this.querySelector('.yg-awards-track');
                if (!track) return;

                // 根据内容宽度动态调整动画速度，保持一致的滚动速度
                const trackWidth = track.scrollWidth / 2; // 除以2因为内容复制了一遍
                const speed = trackWidth / 50; // 每50px约1秒，可以调整这个值来改变速度
                
                track.style.animationDuration = `${speed}s`;
            }
        }

        if (!window.customElements.get('yg-awards-swiper')) {
            window.customElements.define('yg-awards-swiper', YGAwardsSwiper);
        }
    })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-blog-post"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function() {
        class YGBlogPost extends HTMLElement {
            constructor() {
                super();
                this.initSwiper();
            }

            initSwiper() {
                new Swiper(this, {
                    slidesPerView: 1,
                    spaceBetween: 12,
                    breakpoints: {
                        640: {
                            slidesPerView: 1.2,
                            spaceBetween: 12,
                        },
                        1024: {
                            slidesPerView: 1.4,
                            spaceBetween: 24,
                        },
                    },
                    navigation: {
                        nextEl: this.querySelector('.swiper-button-next'),
                        prevEl: this.querySelector('.swiper-button-prev'),
                    },
                    pagination: {
                        el: this.querySelector('.swiper-pagination'),
                        clickable: true,
                        type: 'progressbar'
                    },
                })
            }
        }

        if (!window.customElements.get('yg-blog-post')) {
            window.customElements.define('yg-blog-post', YGBlogPost);
        }
    })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-card-carsouel"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function() {
        class YGCardCarsouel extends HTMLElement {
            constructor() {
                super();
                this.initSwiper();
            }

            initSwiper() {
                new Swiper(this, {
                    slidesPerView: 1.5,
                    spaceBetween: 12,
                    breakpoints: {
                        640: {
                            slidesPerView: 2,
                            spaceBetween: 12,
                        },
                        1024: {
                            slidesPerView: 3.2,
                            spaceBetween: 12,
                        },
                    },
                    navigation: {
                        nextEl: this.querySelector('.swiper-button-next'),
                        prevEl: this.querySelector('.swiper-button-prev'),
                    },
                    pagination: {
                        el: this.querySelector('.swiper-pagination'),
                        clickable: true,
                        type: 'progressbar'
                    },
                })
            }
        }

        if (!window.customElements.get('yg-card-carsouel')) {
            window.customElements.define('yg-card-carsouel', YGCardCarsouel);
        }
    })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-card-swiper"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function() {
        class YGCardSwiper extends HTMLElement {
            constructor() {
                super();
                this.initSwiper();
            }

            initSwiper() {
                new Swiper(this, {
                    slidesPerView: 1.2,
                    spaceBetween: 12,
                    breakpoints: {
                        640: {
                            slidesPerView: 2,
                            spaceBetween: 12,
                        },
                        1024: {
                            slidesPerView: 3,
                            spaceBetween: 12,
                        },
                    },
                    /*navigation: {
                        nextEl: this.querySelector('.swiper-button-next'),
                        prevEl: this.querySelector('.swiper-button-prev'),
                    },
                    pagination: {
                        el: this.querySelector('.swiper-pagination'),
                        clickable: true,
                        type: 'progressbar'
                    },*/
                })
            }
        }

        if (!window.customElements.get('yg-card-swiper')) {
            window.customElements.define('yg-card-swiper', YGCardSwiper);
        }
    })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-category"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function() {
        class YGCategorySwiper extends HTMLElement {
            constructor() {
                super();
                this.initSwiper();
            }

            initSwiper() {
                new Swiper(this, {
                    slidesPerView: 1,
                    spaceBetween: 12,
                    breakpoints: {
                        640: {
                            slidesPerView: 1.4,
                            spaceBetween: 12,
                        },
                        1024: {
                            slidesPerView: 2,
                            spaceBetween: 12,
                        },
                        1280: {
                            slidesPerView: 2.5,
                            spaceBetween: 12,
                        },
                    },
                    navigation: {
                        nextEl: this.querySelector('.swiper-button-next'),
                        prevEl: this.querySelector('.swiper-button-prev'),
                    },
                })
            }
        }

        if (!window.customElements.get('yg-category-swiper')) {
            window.customElements.define('yg-category-swiper', YGCategorySwiper);
        }
    })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-certification"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function() {
        class YGCertification extends HTMLElement {
            constructor() {
                super();
                this.initSwiper();
            }

            initSwiper() {
                new Swiper(this, {
                    slidesPerView: 2,
                    spaceBetween: 6,
                    breakpoints: {
                        700: {
                            slidesPerView: 3,
                            spaceBetween: 12,
                        },
                        1024: {
                            slidesPerView: 4,
                            spaceBetween: 12,
                        },
                    },
                    navigation: {
                        nextEl: this.querySelector('.swiper-button-next'),
                        prevEl: this.querySelector('.swiper-button-prev'),
                    },
                    pagination: {
                        el: this.querySelector('.swiper-pagination'),
                        clickable: true,
                        type: 'progressbar'
                    },
                })
            }
        }

        if (!window.customElements.get('yg-certification')) {
            window.customElements.define('yg-certification', YGCertification);
        }
    })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-collection-with-tab"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGCollectionWithTab extends HTMLElement {
      constructor() {
        super();
        this.initSwiper();
      }

      initSwiper() {
        const thumb = new Swiper(this.querySelector('.yg-thumb-swiper'), {
          slidesPerView: 'auto',
          spaceBetween: 12,
          freeMode: true,
          watchSlidesProgress: true,
          watchOverflow: true,
        });

        const swiper = new Swiper(this.querySelector('.yg-collection-swiper'), {
          slidesPerView: 1,
          spaceBetween: 1000,
          allowTouchMove: false,
          thumbs: {
            swiper: thumb,
          },
        });

        swiper.on('slideChange', () => {
          const thumbnailActive = this.querySelector('.swiper-slide-thumb-active');
          let thumbnailIndex = Array.from(thumbnailActive.parentElement.children).indexOf(thumbnailActive);
          thumb.slideToLoop(swiper.realIndex);
        });
      }
    }

    if (!window.customElements.get('yg-collection-with-tab')) {
      window.customElements.define('yg-collection-with-tab', YGCollectionWithTab);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-scroll-image"] && !Shopify.designMode) return;
  try {
    
    class YGScrollImage extends HTMLElement {
    constructor() {
        super();
        this._init();
    }

    _init() {
        const sectionId = this.getAttribute("data-section-id");
        if (!sectionId) return;

        // 等待图片加载完成后再计算
        this._waitForImages().then(() => {
        this._calculateAnimation();
        });

        // 监听窗口大小变化
        if (window.ResizeObserver) {
        new ResizeObserver(() => {
            this._calculateAnimation();
        }).observe(this);
        }

        // 鼠标悬停暂停/恢复
        const container = document.getElementById(`yg-scrolling-container-${sectionId}`);
        if (container) {
        container.addEventListener('mouseenter', () => this._pauseScrolling());
        container.addEventListener('mouseleave', () => this._resumeScrolling());
        }
    }

    _waitForImages() {
        return new Promise((resolve) => {
        const images = this.querySelectorAll('yg-image img, yg-image svg');
        if (images.length === 0) {
            resolve();
            return;
        }

        let loadedCount = 0;
        const totalImages = images.length;

        const checkComplete = () => {
            loadedCount++;
            if (loadedCount >= totalImages) {
            // 额外等待一小段时间确保布局稳定
            setTimeout(resolve, 100);
            }
        };

        images.forEach((img) => {
            if (img.complete) {
            checkComplete();
            } else {
            img.addEventListener('load', checkComplete, { once: true });
            img.addEventListener('error', checkComplete, { once: true });
            }
        });
        });
    }

    _calculateAnimation() {
        const scrollingSpeed = parseFloat(this.getAttribute("scrolling-speed") || 45);
        const sectionId = this.getAttribute("data-section-id");
        
        // 获取第一个滚动元素的宽度
        const firstElement = this;
        const elementWidth = firstElement.offsetWidth;
        
        if (elementWidth === 0) {
        // 如果宽度为0，延迟重试
        setTimeout(() => this._calculateAnimation(), 100);
        return;
        }

        // 获取两个元素之间的 gap（从父元素获取）
        const listElement = document.getElementById(`yg-scrolling-list-${sectionId}`);
        const computedStyle = window.getComputedStyle(listElement);
        const gap = parseFloat(computedStyle.gap) || 0;
        
        // 动画移动的距离 = 元素宽度 + gap（这样第二个元素才能无缝接上）
        const moveDistance = elementWidth + gap;

        // 计算动画时长：速度越大，移动越快（时长越短）
        // scrollingSpeed 表示每秒移动的像素数
        const duration = moveDistance / scrollingSpeed;

        // 设置CSS变量
        this.style.setProperty('--marquee-width', `${moveDistance}px`);
        this.style.setProperty('--marquee-duration', `${duration}s`);

        // 确保所有元素使用相同的动画参数
        const allElements = document.querySelectorAll(`yg-scroll-image[data-section-id="${sectionId}"]`);
        allElements.forEach((el) => {
        if (el !== this) {
            el.style.setProperty('--marquee-width', `${moveDistance}px`);
            el.style.setProperty('--marquee-duration', `${duration}s`);
        }
        });
    }

    _pauseScrolling() {
        const sectionId = this.getAttribute("data-section-id");
        const allElements = document.querySelectorAll(`yg-scroll-image[data-section-id="${sectionId}"]`);
        allElements.forEach((item) => {
        item.style.animationPlayState = 'paused';
        });
    }

    _resumeScrolling() {
        const sectionId = this.getAttribute("data-section-id");
        const allElements = document.querySelectorAll(`yg-scroll-image[data-section-id="${sectionId}"]`);
        allElements.forEach((item) => {
        item.style.animationPlayState = 'running';
        });
    }
    }

    if (!window.customElements.get("yg-scroll-image")) {
    window.customElements.define("yg-scroll-image", YGScrollImage);
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-success-stories"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function() {
        class YGSuccessStories extends HTMLElement {
            constructor() {
                super();
                this.initSwiper();
            }

            initSwiper() {
                new Swiper(this, {
                    slidesPerView: 1,
                    spaceBetween: 12,
                    breakpoints: {
                        640: {
                            slidesPerView: 1.2,
                            spaceBetween: 12,
                        },
                        1024: {
                            slidesPerView: 1.4,
                            spaceBetween: 12,
                        },
                    },
                    navigation: {
                        nextEl: this.querySelector('.swiper-button-next'),
                        prevEl: this.querySelector('.swiper-button-prev'),
                    },
                    pagination: {
                        el: this.querySelector('.swiper-pagination'),
                        clickable: true,
                        type: 'progressbar'
                    },
                })
            }
        }

        if (!window.customElements.get('yg-success-stories')) {
            window.customElements.define('yg-success-stories', YGSuccessStories);
        }
    })

  } catch(e) { console.error(e); }
})();
})();
